import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { AccessibilityWrapper, Icon } from 'legacy-packages/ft-cb';

import './StudentResponsesHelper.scss';

const StudentResponsesHelper = (props) => {
  const {
    children,
    studentId,
    params: { subject, assignmentId, questionId, partId },
    isStudent,
    responsesPath,
    router,
  } = props;

  const mainPath = `/${subject}/assessments/results/${assignmentId}/`;
  let studentResponsesPath = `${mainPath}${
    isStudent ? 'performance' : `students/${studentId}`
  }/responses`;

  if (questionId) {
    studentResponsesPath += `/questions/${questionId}`;

    if (partId) {
      studentResponsesPath += `/parts/${partId}`;
    }
  }

  const goToResponses = () =>
    router.push(responsesPath || studentResponsesPath);

  return (
    <AccessibilityWrapper>
      <div
        className="StudentResponses"
        tabIndex={0}
        role="button"
        onClick={goToResponses}
      >
        <div
          data-test-student-responses-link
          className="view-student-responses"
        >
          {children}{' '}
          <span>
            <Icon name="arrow-north-west" size="1.8rem" />
          </span>
        </div>
      </div>
    </AccessibilityWrapper>
  );
};

StudentResponsesHelper.propTypes = {
  /**
   * Student id for setting modal context with new pathname
   * */
  studentId: PropTypes.string.isRequired,
};

export default withRouter(StudentResponsesHelper);
